module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAA80lEQVR4Ae2WgQbDQAyG8wwz2LZ3Ghj6ENs7DVvrqKLYuxRgWrC9wrZ8AF279rhr4H5+PUlO/jZJRRISQFmW+zzPb4pO+YnMjlzkFOCc26nhhXNhPsktmvyKwYLkRkBrKKCVEedDmWmdNpAztqFY8cTP/aHkWpuV9IAN3xICsj+Xs358URRHH04K4JPLCPCFqr+9gFAl8GfYJmSUnA/nCDAfQ97qrh170OcWcsa2lICTjEBFnGOX4CITICZKE6q6d13Xa5kAMcTGmILGo45NDAGVh4Aq+K+YBpGZIDbQFNgLMF9I7FcyFkMWRKul1HwtT0j4AmTppJ14BoCuAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user-info.png
// module id = 191
// module chunks = 35783957827783 112966903596346 114276838955818